'use strict';

/**
 * Cleans up previously selected / sets new selection
 */
export default (combobox, listbox, nativeSelect, noHide) => {
	// clear selected state

	const prevSelected = listbox.querySelector('[aria-selected="true"]');
	if (prevSelected) {
		prevSelected.removeAttribute('aria-selected');
	}

	const active = listbox.querySelector('.accessible-option-active');
	if (active) {
		active.setAttribute('aria-selected', 'true');
	}

	if (!noHide) {
		// hide the list
		listbox.classList.remove('accessible-listbox-show');
		combobox.setAttribute('aria-expanded', 'false');
	}
	nativeSelect.value = active.getAttribute('value');

	const changeEvent = new Event('change', { bubbles: true, cancelable: false });
	nativeSelect.dispatchEvent(changeEvent);

	const inputEvent = new Event('input', { bubbles: true, cancelable: false });
	nativeSelect.dispatchEvent(inputEvent);

	// set pseudoVal
	const pseudoVal = active && combobox.querySelector('.accessible-pseudo-value');
	if (pseudoVal) {
		pseudoVal.innerHTML = active.innerHTML;
	}
};
